<template>
  <div :class="theme_.container" :title="title" :style="styles" v-html="icon" />
</template>

<script>
export const DEFAULT_THEME = {
  container: ["flex", "items-center", "justify-center", "bg-none"],
};

export default {
  name: "AppSvgSymbol",
  props: {
    name: {
      default: "",
      type: String,
      required: true,
    },
    title: {
      default: "",
      type: String,
    },
    size: {
      default: 24,
      type: [Number, String],
    },
    sizeUnit: {
      default: "px",
      type: String,
    },
    height: {
      default: null,
      type: [Number, String, null],
    },
    width: {
      default: null,
      type: [Number, String, null],
    },
    type: {
      type: String,
      default: "outline",
    },
    iconsPath: {
      type: String,
      default: "assets/sprite/svg/",
    },
    theme: {
      type: Object,
      default: () => DEFAULT_THEME,
    },
  },
  computed: {
    theme_() {
      return {
        ...DEFAULT_THEME,
        ...this.theme,
      };
    },
    icon() {
      if (
        typeof this.name === "string" &&
        this.name.startsWith("@escavador/")
      ) {
        return require(`@escavador/svg-icons/${this.name.replace(
          "@escavador/",
          ""
        )}/${this.type}.svg?raw`);
      }

      if (this.iconsPath && this.name) {
        return require(`~/${this.iconsPath}${this.name}.svg?raw`);
      }

      return "";
    },
    styles() {
      const getSize = (size) => {
        const sizeWords = ["auto", "none"];
        return (
          (sizeWords.includes(size) && size) ||
          `${(size !== null && size) || this.size}${this.sizeUnit}`
        );
      };
      return {
        width: getSize(this.width),
        height: getSize(this.height),
      };
    },
  },
};
</script>

<style scoped>
:deep(svg) {
  width: inherit;
  height: inherit;
}
</style>
